import { ReminderContext, ReminderEntityType } from './types';

const stripAccountPath = ( pathname: string ): string => pathname.replace( /^\/u\/\d+/, '' );

const extractEntityType = ( pathname: string ): ReminderEntityType | undefined => {
  const url = stripAccountPath( pathname );

  if ( url.startsWith( '/claims' ) ) return ReminderEntityType.CLAIM;
  if ( url.startsWith( '/policies' ) ) return ReminderEntityType.POLICY;
  if ( url.startsWith( '/leads' ) ) return ReminderEntityType.LEAD;
  if ( url.startsWith( '/partners' ) ) return ReminderEntityType.PARTNER;
};

const extractCode = ( pathname: string, entityType?: ReminderEntityType ): string | undefined => {
  if ( !entityType ) {
    return undefined;
  }

  const pathParts = stripAccountPath( pathname ).split( '/' ).filter( Boolean );

  if ( entityType === ReminderEntityType.PARTNER ) {
    return pathParts[2];
  }

  return pathParts[1];
};

export const getReminderContext = ( pathname: string ): ReminderContext => {
  const entityType = extractEntityType( pathname );
  const code = extractCode( pathname, entityType );

  return {
    entityType: entityType && code ? entityType : undefined,
    code: entityType && code ? code : undefined,
  };
};

export const createReminderUrl = ( userPrefix: string, context: ReminderContext ): string => {
  if ( context.code && context.entityType ) {
    return `${userPrefix}/reminders/create?entityType=${context.entityType}&entityCode=${context.code}`;
  }

  return `${userPrefix}/reminders/create`;
};

export const createAllRemindersUrl = ( userPrefix: string, amount: number ): string => {
  if ( amount > 0 ) {
    return `${userPrefix}/reminders?status=due%2Coverdue&dueAtFilter=all&order=dueAt&direction=DESC`;
  }

  return `${userPrefix}/reminders?order=dueAt&direction=DESC`;
};
